import {  useEffect, useState } from 'react';
import { useCart } from '../../context/CartProvider';
import DrawerSelect from '../ui/DrawerSelect';
import ImageWithFallback from '../ui/ImageWithFallback';

const {
    lang_material_variant,
    lang_material_quantity,
    lang_material_size,
    lang_added_to_cart,
    lang_back_to_cart,
    lang_back_to_orders,
    lang_save_changes,
    lang_saved_changes,
    is_cart_limit_applicable_active_flag,
    lang_cart_limit,
    template_directory_uri
} = window.ordering_cart_script_checkout;

const EditDrawer = () => {
    const { editResource, setEditResource, isItemAddedToCart, isItemChangedInCart, isItemSavedInCart, editItemOnChange, isLimitQuantityFlagEditItemSave, editItemSaveChanges, } = useCart()
    const [orderPage, setOrderPage] = useState(false);
    const [editableData, setEditableData] = useState(null);

    /**
     * Effect to fetch the edit item data when the component mounts.
     * This function retrieves the selected cart item from localStorage
     */
    const fetchEditItemDataBtn = () => {
        const localEditResource = JSON.parse(localStorage.getItem('selectedCartItem'));
        setEditResource(localEditResource);
        setEditableData(localEditResource);
        // Check if the localEditResource is not null or undefined
        const rawPath = window.location.pathname;
        // Decode the rawPath and sanitize it
        const currentPath = decodeURIComponent(rawPath).replace(/[^a-zA-Z0-9/_-]/g, '');
        if (currentPath.includes('checkout')) {
            setOrderPage(true);
        } else {
            setOrderPage(false);
        }
    };

    return (
        <div className="offcanvas offcanvas-end" id="orderingCartEditItemDivReact">
            <div className="offcanvas-header" style={{ padding: '2.4rem 2.9rem 0.4rem' }}>
                {!orderPage ?<a className="editItemBackToCartLink" href="#" data-bs-toggle="offcanvas" data-bs-target="#organonOrderingCartOffcanvasReact" id="editItemBacktoCheckoutBtn">&lt; {lang_back_to_cart}</a>:<a className="editItemBackToCartLink" href="#" data-bs-dismiss="offcanvas" id="editItemBacktoCheckoutBtn">&lt; {lang_back_to_orders}</a>}
                <button type="button" className="btn-close" data-bs-dismiss="offcanvas" id="closeButtonreachlimiteditItemBackToCart"></button>
                <button className='d-none' id="fetchEditItemDataBtn" onClick={fetchEditItemDataBtn}></button>
            </div>
            <div className="offcanvas-body" id="cartFormBody">
                <div className="cart-edit-item-card-body">
                    <div className="cart-item-card-single-edit">
                        <div className="row align-items-center">
                            <div className="col-3 mycart-edit-items">
                                <div className="no-gutters">
                                    <div className="cart-item-card-body-img-div col-12">
                                        {
                                         editableData?.material_image ? <ImageWithFallback className="cart-item-card-body-img edit-cart-drawer-item" src={editableData?.material_image} alt={editableData?.post_title} fallback={`${template_directory_uri}/assets/images/no_preview.png`} /> : <ImageWithFallback className="cart-item-card-body-img edit-cart-drawer-item" src={`${template_directory_uri}/assets/images/no_preview.png`} alt={editableData?.post_title} />
                                        }
                                    </div>
                                </div>
                            </div>
                            <div className="col-9 nopadding">
                                <div className="no-gutters">
                                    <div className="col-12">
                                        <p className="h5Cart">{editableData?.post_title}</p>
                                        <p className="pCart">{editableData?.product_short_description}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {
                        editableData?.is_long_description && <div className="row">
                            <div className="col-12">
                                <p className="editItemLongDesc mb-2">{editableData?.material_long_description}</p>
                            </div>
                        </div>
                    }
                    {
                        editableData?.is_material_size && <DrawerSelect id="order_size" label={lang_material_size} name="order_size" value={editableData.order_size || ""} data={editableData.material_size} onChange={(e) => {
                            setEditableData((prev) => ({
                                ...prev,
                                order_size: e.target.value,
                            }));
                            editItemOnChange();
                        }} />
                    }
                    {
                        editableData?.is_material_variant && <DrawerSelect id="order_variant" label={lang_material_variant} name="order_variant" value={editableData.order_variant || ""} data={editableData.material_variant} onChange={(e) => {
                            setEditableData((prev) => ({
                                ...prev,
                                order_variant: e.target.value,
                            }));
                            editItemOnChange();
                        }} />
                    }
                    {
                        editableData?.product_quantity?.length && <DrawerSelect id="order_quantity" label={lang_material_quantity} name="order_quantity" value={editableData.order_quantity || ""} data={editableData.product_quantity} onChange={(e) => {
                            setEditableData((prev) => ({
                                ...prev,
                                order_quantity: e.target.value,
                            }));
                            editItemOnChange();
                        }} />
                    }
                    <div className="row">
                        <div className="col-12">
                            <div className="col-12 hrline"></div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12 ">
                            <div className="ordering-cart-order-now-div">
                                {isItemAddedToCart && <button type='button' disabled={isItemAddedToCart} className="btn editItemAddedToCartButton col">
                                    {lang_added_to_cart}
                                </button>}

                                {isItemChangedInCart  && (
                                    is_cart_limit_applicable_active_flag && is_cart_limit_applicable_active_flag === "1" ? (
                                        <button type='button'
                                            className="edit-item-save-changes-btn reachquantity"
                                            onClick={() => isLimitQuantityFlagEditItemSave(editableData, `${lang_cart_limit}`, orderPage)}
                                        >
                                            {lang_save_changes}
                                        </button>
                                    ) : (
                                        <button type='button'
                                            className="edit-item-save-changes-btn"
                                            onClick={() => editItemSaveChanges(editableData, orderPage)}
                                        >
                                            {lang_save_changes}
                                        </button>
                                    )
                                )}
                                {isItemSavedInCart && <button type='button' disabled={isItemSavedInCart} className="btn editItemAddedToCartButton col">
                                    {lang_saved_changes}
                                </button>}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default EditDrawer